<template>
    <div>
        <v-list>
            <template v-for="request in requests">
            <v-list-item :key="request.id" :disabled="disabledRequests.includes(request.id)" class="py-md-2 px-2 px-md-4 rounded mb-2" :class="{'bordered': pcOnly}"> 
                <v-list-item-avatar color="indigo lighten-5" text :size="pcOnly ? 60 : 36" dark class="mt-4" :class="{'me-2': phoneOnly}" style="align-self: start;">
                    <v-icon color="indigo" :size="pcOnly ? 32 : 20">mdi-clock-edit</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                    <v-list-item-title class="d-flex align-center">
                        <div>
                            {{request.sender.name}} - {{ request.enrollment.course.name }}
                        </div>
                        <div class="ms-2">
                            <v-chip v-if="request.permanent" color="primary" small label>
                                <v-icon size="20" left class="me-1">mdi-repeat</v-icon>
                                <strong>Permanent Reschedule</strong>
                            </v-chip>
                            <v-chip v-else small label outlined>
                                one class
                            </v-chip>
                        </div>
                    </v-list-item-title>
                    <v-list-item-subtitle>
                        <div>
                            From
                            <v-icon size="17" class="me-1" color="strong-text" style="line-height: 0;">mdi-clock-outline</v-icon>
                            <strong class="strong-text--text">{{request.old_start_formated}}</strong>
                        </div>
                        <div>
                            To
                            <v-icon size="17" class="me-1" color="indigo" style="line-height: 0;">mdi-clock-outline</v-icon>
                            <strong class="indigo--text text--darken-2">{{request.start_formated}}</strong>
                        </div>
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                        <div v-if="request.reason" style="white-space: pre-line;" class="text--text">
                            <span class="muted--text">Reason:</span>
                            {{request.reason}}
                        </div>
                    </v-list-item-subtitle>
                    <div v-if="phoneOnly">
                        <v-btn color="indigo" depressed dark @click="showApproveDialog(request)" :disabled="disabledRequests.includes(request.id)" class="mb-md-1 me-2 me-md-0">
                            <v-icon left>mdi-clock-check-outline</v-icon>
                            <span>Accept</span>
                        </v-btn>
                        <v-btn color="red" dark depressed @click="showRejectDialog(request)" :disabled="disabledRequests.includes(request.id)">
                            Reject
                        </v-btn>
                    </div>
                </v-list-item-content>
                <v-list-item-icon v-if="pcOnly" class="d-flex flex-column">
                    <v-btn color="indigo" depressed dark @click="showApproveDialog(request)" :disabled="disabledRequests.includes(request.id)" class="mb-1">
                        <v-icon left>mdi-clock-check-outline</v-icon>
                        <span>Accept</span>
                    </v-btn>
                    <v-btn color="red" dark depressed @click="showRejectDialog(request)" :disabled="disabledRequests.includes(request.id)">
                        Reject
                    </v-btn>
                </v-list-item-icon>
            </v-list-item>
            <v-divider v-if="phoneOnly"  :key="'d' + request.id"></v-divider>
            </template>
        </v-list>


        <v-dialog transition="slide-y-transition" v-model="approveDialog" max-width="350">
            <v-card>
                <v-card-title>Accept Reschedule Reuest</v-card-title>
                <v-card-text>
                    Are you sure that you want to accept this request?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="muted" :disabled="approving" @click="approveDialog = false">Cancel</v-btn>
                    <v-btn :loading="approving" :disabled="approving" text color="indigo" @click="approveRequest(approveRequestId)">Confirm</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog transition="slide-y-transition" v-model="rejectDialog" max-width="350">
            <v-card>
                <v-card-title>Reject Reschedule Request</v-card-title>
                <v-card-text>
                    Are you sure that you want to reject this request?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="muted" :disabled="rejecting" @click="rejectDialog = false">Cancel</v-btn>
                    <v-btn :loading="rejecting" :disabled="rejecting" text color="red" @click="rejectRequest(rejectRequestId)">Confirm</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import { template } from 'lodash';
export default {
    props: {
        requests: Array
    },
    data(){
        return {
            approving: false,
            approveRequestId: null,
            approveDialog: false,

            rejecting: false,
            rejectRequestId: null,
            rejectDialog: false,

            disabledRequests: [],
        }
    },
    computed: {
        ...GlobalComputed,

    },
    methods: {
        ...GlobalMethods,

        showApproveDialog(request){
            this.approveRequestId = request.id;
            this.approveDialog = true;
        },
        showRejectDialog(request){
            this.rejectRequestId = request.id;
            this.rejectDialog = true;
        },
        approveRequest(id){
            if (!this.approving){
                this.approving = true;
                return this.$store.dispatch('rescheduleRequestAction', {action: 'approve', id: this.approveRequestId}).then(response=>{
                    this.approving = false;
                    this.approveDialog = false;
                    this.disabledRequests.push(this.approveRequestId);
                    this.showMsg('Reschedule has been approved successfully', 'success');
                    // this.$router.push({name: 'calendar'});
                }).catch(error=>{
                    this.approving = false;
                    this.showMsg('Error occurred during preforming your action', 'error');
                })
            }
        },
        rejectRequest(id){
            if (!this.rejecting){
                this.rejecting = true;
                return this.$store.dispatch('rescheduleRequestAction', {action: 'reject', id: this.rejectRequestId}).then(response=>{
                    this.rejecting = false;
                    this.showMsg('Reschedule request rejected successfully', 'success');
                    this.rejectDialog = false;
                    this.disabledRequests.push(this.rejectRequestId);
                }).catch(error=>{
                    this.rejecting = false;
                    this.showMsg('Error occurred during preforming your action', 'error');
                })
            }
        },
    }
}
</script>

<style lang="scss" scoped>

</style>